'use client'

import { setNavStateContext } from '@/contexts/setNavState'
import type { MenuItemType } from '@/frontend-types'
import usePathnameWithSearch from '@/hooks/usePathnameWithSearch'
import { cx } from 'cva'
import Link from 'next/link'
import { useContext, type FC, type PropsWithChildren } from 'react'

export type MenuItemLinkProps = Pick<MenuItemType, 'href' | 'target'> & {
	className?: string
	linkClassName?: string
}

const menuTextHoverClasses =
	'text-white hover:text-blue-tint-20 focus:text-white transition-colors duration-200 ease-in-out'

export const MenuItemLink: FC<PropsWithChildren<MenuItemLinkProps>> = ({
	href,
	target,
	className,
	linkClassName = className,
	children,
}) => {
	const pathname = usePathnameWithSearch()
	const setNavState = useContext(setNavStateContext)

	// Close menu overlay if navigating to the current page, including query params
	const handleNavigate = () => {
		const [target] = href?.split('#') ?? []
		if (target === pathname) setNavState('closed')
	}

	return href ? (
		<Link
			href={href}
			target={target}
			className={cx(linkClassName, menuTextHoverClasses)}
			onNavigate={handleNavigate}
		>
			{children}
		</Link>
	) : (
		<span className={className}>{children}</span>
	)
}
